// @ts-nocheck
import {NavLink} from 'react-router-dom'
import {KTSVG} from '../../../../../../_metronic/helpers'
import {useListView} from '../../core/ListViewProvider'
import {UsersListFilter} from './ReportsListFilter'

const UsersListToolbar = ({
  setSDate,
  setEDate,
  sDate,
  eDate,
  page,
  setPage,
  status,
  category,
  setStatus,
  setCategory,
}) => {
  const {setItemIdForUpdate} = useListView()
  const openAddUserModal = () => {
    setItemIdForUpdate(null)
  }

  return (
    <div className='d-flex justify-content-end' data-kt-user-table-toolbar='base'>
      <UsersListFilter
        sDate={sDate}
        setSDate={setSDate}
        setEDate={setEDate}
        eDate={eDate}
        page={page}
        setPage={setPage}
        status={status}
        setCategory={setCategory}
        setStatus={setStatus}
        category={category}
      />
    </div>
  )
}

export {UsersListToolbar}
